// extracted by mini-css-extract-plugin
export var band = "color-bar-module--band--xNLGG";
export var bands = "color-bar-module--bands--ZuyR7";
export var color = "color-bar-module--color--w9dKb";
export var root = "color-bar-module--root--cdpiI";
export var sticky = "color-bar-module--sticky--yPNZe";